import sdl from '@jds/react-generated-sdl/JDSListBlock';
import type { JDSListBlockProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ListBlockProps } from '../logic';

const Component = (props: ListBlockProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    spacing = 'medium',
    verticalAlignment = 'middle',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { spacing, verticalAlignment, ...rest },
    'JDSListBlock',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const ListBlock = withLogic(Component) as React.FC<ListBlockProps> & {
  slotName?: string;
};

ListBlock.displayName = 'ListBlock';
ListBlock.slotName = 'jds_list_block';

export { ListBlock, type JDSListBlockProps };
